import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TableGeneralSimpleComponent } from '../../components-generals/table-general-simple/table-general-simple.component';

@Component({
  selector: 'app-reader-table',
  standalone: true,
  imports: [CommonModule, TableGeneralSimpleComponent],
  templateUrl: './reader-table.component.html',
  styleUrl: './reader-table.component.scss',
})
export class ReaderTableComponent {
  @ViewChild('paginator') paginator!: MatPaginator;
  public URL_API = environment.apiURLNew;
  public load = false;
  public headers: { value: string; description: string }[] = [];
  public dataSource = new MatTableDataSource<any>([]);
  @Input() quotationId = 0;
  @Input() url = '';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.getTable();
  }

  public getTable(): void {
    this.load = true;
    this.http
      .get(this.URL_API + this.url + this.quotationId, {})
      .pipe(
        catchError(() => {
          return of(null);
        }),
      )
      .subscribe((ress: any | null) => {
        if (!ress || !Array.isArray(ress) || !ress.length) {
          this.headers = [];
          this.dataSource.data = [];
          this.load = false;
          return;
        }
        this.headers = Object.keys(ress[0]).map((key) => ({
          value: key,
          description: key,
        }));

        this.dataSource.data = ress as any[];
        this.load = false;
      });
  }

  public activityfuntion(id: string | number): void {}
}
